__webpack_require__.p = "/servicedesk-dashboard/";